import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  AbstractFieldInputTypeHandlerComponent,
  FormValueReadableValue
} from '../../type-handler/abstract-field-input-type-handler.component';
import {UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {
  FormDefinitionFieldModel
} from '../../../../../../modules/form/definition/field/api/entity/formDefinitionField.model';
import {FormValueModel} from '../../../../../../modules/form/form/value/api/entity/formValue.model';
import {SelectElement} from '../../../../select/select.model';
import {
  FormFieldDefinitionOptionModel
} from "../../../../../../modules/form/definition/field/api/entity/formFieldDefinitionOption.model";
import {ChipItem} from "../../../../../../modules/core/component/chip/chip.component";

@Component({
  selector: 'app-select-many-field-input-type-handler',
  templateUrl: './select-many-field-input-type-handler.component.html'
})
export class SelectManyFieldInputTypeHandlerComponent extends AbstractFieldInputTypeHandlerComponent<UntypedFormControl>
    implements OnInit {

  chipItems: ChipItem<string>[] = [];

  public static resolveReadableValues(value: any,
                                      unit: string,
                                      options: FormFieldDefinitionOptionModel[]): Promise<FormValueReadableValue[]> {
    const values: FormValueReadableValue[] = [];
    if (value) {
      const parsed = JSON.parse(value);
      const parsedValues: string[] = parsed.values;
      parsedValues.forEach((value: any) => {
        const option = options?.find(value1 => value1.value === value)
        values.push(FormValueReadableValue.ofText(option ? option?.label : '?'));
      })
    }
    return Promise.resolve(values);
  }

  elements: SelectElement[] = [];

  constructor(private formBuilder: UntypedFormBuilder) {
    super();
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): UntypedFormControl {
    this.elements = formDefinitionField.options.map(value => new SelectElement(value.value, value.label));
    this.chipItems = formDefinitionField.options.map(value => ChipItem.createChipItem(value.value, value.label));

    const initialValue = [];
    if (formDefinitionField.defaultValue) {
      initialValue.push(formDefinitionField.defaultValue);
    }
    return this.formBuilder.control(initialValue, formDefinitionField.required ? Validators.required : []);
  }

  initiateForm(formValue: FormValueModel): void {
    if (formValue?.value) {
      let values;
      try {
        values = JSON.parse(formValue.value).values;
      } catch (e) {
        values = formValue.value;
      }
      this.jsonControl.patchValue(values);
    } else if (formValue?.fieldDefinition?.defaultValue) {
      this.jsonControl.patchValue([formValue?.fieldDefinition?.defaultValue]);
    }
    this.synchronizeChipsState();
  }

  synchronizeChipsState() {
    const values: [] = this.jsonControl.value;
    if(values) {
      values.forEach(value => {
        const item = this.chipItems.find(value1 => value1.value == value);
        if (item) {
          item.selected = true;
        }
      })
    }
  }

  chipItemsSelectionChanged() {
    const selectedItems = this.chipItems.filter(value => value.selected);
    this.jsonControl.setValue(selectedItems
        .map(value => value.value));
  }

  synchronizeValue(): string {
    return this.resolveJsonFromValue(this.jsonControl.value);
  }

  resolveJsonFromValue(values: string[]): string {
    return JSON.stringify(new SelectManyFieldInputTypeHandlerComponentValue(values));
  }

  focussed() {
    this.setMeasured(true);
  }
}

export class SelectManyFieldInputTypeHandlerComponentValue {
  values: string[];
  constructor(values: string[]) {
    this.values = values;
  }
}
